// import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined';ss


const NoRecordFound = ({ marginTop = '10%', height = '100%' }) => {
    return (
        <div
            style={{
                textAlign: 'center',
                height: `${height}`,
                marginTop: `${marginTop}`,
            }}
        >
            {/* <div>
                <FindInPageOutlinedIcon></FindInPageOutlinedIcon>
            </div> */}
            <div>
                <span>No records were found.</span>
            </div>
        </div>
    );
};
export default NoRecordFound;